import { fetcher } from "helpers/fetcher";

import { TUpdateScorecardStaffReq, TUpdateScorecardStaffRes } from "./types";
import { MANAGEMENT_ENDPOINTS } from "./endpoint";
import { API_HEADER } from "api/constants";

export const updateScorecardStaff = async (
  payload: TUpdateScorecardStaffReq
) => {
  return await fetcher<
    TUpdateScorecardStaffRes,
    TUpdateScorecardStaffReq["data"]
  >(MANAGEMENT_ENDPOINTS.UPDATE_SCORECARD_STAFF, {
    headers: {
      [API_HEADER.BU_ID]: payload.idBu,
    },
    data: payload.data,
    urlData: payload.urlData,
  });
};

export const mutationUpdateScorecardStaff = async (
  payload: TUpdateScorecardStaffReq
) => {
  return (await updateScorecardStaff(payload)).data;
};

mutationUpdateScorecardStaff._key = (payload: TUpdateScorecardStaffReq) => [
  MANAGEMENT_ENDPOINTS.UPDATE_SCORECARD_STAFF.url,
  payload,
];
